import NewApiService from "@/utils/new.api.service";

export default {
    list() {
        return new Promise((resolve, reject) => {
            NewApiService.get("brand")
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    create(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.post("brand",model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    update(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.put("brand/"+model.id,model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    delete(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.delete("brand/"+model.id)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    }
    
}